/*
  =====================================================
  Lee Flora Wholesale — Florist Directory Page JS
  FILE: assets/lfw-florist-directory.js
  SCOPE: Only loaded on page.florist-directory template
  =====================================================
*/

(function () {
  'use strict';

  // ── FAQ Accordion ──────────────────────────────────
  // Scoped to .lfw-fd-faq containers only — will not touch other accordions.
  document.querySelectorAll('.lfw-fd-faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement;
      var section = item.closest('.lfw-fd-faq');
      if (section) {
        section.querySelectorAll('.lfw-fd-faq__item.lfw-open').forEach(function (open) {
          if (open !== item) open.classList.remove('lfw-open');
        });
      }
      item.classList.toggle('lfw-open');
    });
  });

    document.querySelectorAll('.lfw-fd-card--linked').forEach(function (card) {
    var url = card.getAttribute('data-href');
    if (!url) return;

    card.addEventListener('click', function (e) {
      // Don't hijack clicks on inner anchors (clickable tags)
      if (e.target.closest('a')) return;
      window.open(url, '_blank', 'noopener');
    });

    // Keyboard accessibility — Enter or Space activates the card
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (e.target.closest('a')) return;
        e.preventDefault();
        window.open(url, '_blank', 'noopener');
      }
    });
  });

  // ── Scroll Animate ─────────────────────────────────
  // Only animates elements inside .lfw-fd-page (the template wrapper).
  var animateEls = document.querySelectorAll('.lfw-fd-page .lfw-animate');
  if (animateEls.length > 0) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lfw-show');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    animateEls.forEach(function (el) {
      observer.observe(el);
    });
  }
})();
